import './Filter.scss';

import React from 'react';
import AutoCompleteSelect from './AutoCompleteSelect';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/EditSharp';
import { useDispatch } from 'react-redux';
import DeviceSelectorField from './DeviceSelectorField';
import { ClickAwayListener } from '@mui/material';
import { useTranslation } from 'src/i18n';

// Map filter types to translation keys
const filterLabelKeys: Record<string, string> = {
  'priority': 'filters.priority',
  'commodity': 'filters.commodity',
  'location': 'filters.location',
  'unit': 'filters.unit',
  'system': 'filters.system',
  'controller': 'filters.controller',
  'settings': 'filters.settings',
  'dead leg': 'filters.deadLeg',
  'device_group': 'filters.deviceGroup',
};

export default function  Filter (props) {
  const { t } = useTranslation();
  const {
    type,
    options,
    onChange,
  } = props;
  const label = t(filterLabelKeys[type] || type);
  const [edit, setEdit] = React.useState(false);
  const dispatch = useDispatch();

  // Normalize value to the format expected by the component
  const normalizeValue = React.useCallback((value: any) => {
    if (value === '' || value === null || value === undefined) {
      return { label: t('common.all'), value: '' };
    }
    if (type === "controller") {
      return value?.tag
        ? { label: value.tag, value: value.tag }
        : { label: t('common.all'), value: '' };
    }
    return { label: value, value: value };
  }, [type, t]);

  const [value, setValue] = React.useState(() => normalizeValue(props.value));
  const optionsArray = [];

  // Sync local state when props.value changes (e.g., when filter is cleared)
  React.useEffect(() => {
    setValue(normalizeValue(props.value));
  }, [props.value, normalizeValue]);

  if (type !== 'controller') {
    if (options && options.forEach) {
      options?.forEach(opt => (opt.get(type.toLowerCase()) === null ||
        opt.get(type.toLowerCase()) === '') ? '' : optionsArray.push(opt.get(type.toLowerCase())));
    }
  }


  const onClick = () => {
    setEdit(true);
  };

  const handleChange = (value, title) => {
    if ((value === null) && (title === null)) {
      return;
    } else if ((value === null || value === '')) {
      setValue(normalizeValue(null));
      dispatch(onChange(null));
      return;
    } else {
      setValue(normalizeValue(value));
      dispatch(onChange(value));
    }
    setEdit(false);
  };

  if (optionsArray.length === 0 && (type !== 'controller' && type !== 'settings')) {
    return (<></>);
  }

  const onClickAwayHandler = () => {
    setEdit(false);
    if (value === null || (value as any) === '') {
      setValue({ label: t('common.all'), value: 'all' });
      dispatch(onChange(null));
    }
  };
  return (
    <div>
      <div className='filter-container'>
        <div className='label'>
          {label}
        </div>
        <div className='value'>
          {edit ?
            <ClickAwayListener onClickAway={onClickAwayHandler}>
              <div>
                {type === 'controller' ?
                  <DeviceSelectorField deviceId={props.value && props.value.id ? props.value.id : null} value={value} hideLabel={true} onChange={handleChange} error={false} helperText='' type='controller' />
                  :
                  <AutoCompleteSelect onChangeFn={handleChange} options={optionsArray} id={type} initialValues={value.value === '' ? null : value} />
                }
              </div>
            </ClickAwayListener>
            :
            <span>
              <span className='text'>
                {value.label}
              </span>
              <EditIcon className='icon' onClick={onClick} />
            </span>
          }
        </div>
      </div>
    </div>


  );
}

Filter.propTypes = {
  type: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.any,
  onChange: PropTypes.func
};

Filter.defaultProps = {
  type: '',
  value: null,
  options: [],
  onChange: null
};
